import {
  ExperimentAndVariation,
  ExperimentDefinition,
  getExperimentState,
  getExperimentsJourney,
} from "./meristemContext";
import { captureException } from "./error";

/**
 * Fetch the experiment assignment from the embedded Meristem Context.
 */
export function getStoredExperiments(): ExperimentDefinition[] | null {
  let experimentStates = getExperimentState();
  if (experimentStates.length) {
    if (typeof experimentStates === "string") {
      experimentStates = JSON.parse(experimentStates);
    }
    return [].concat(experimentStates);
  }
  return null;
}

/**
 * Get visited experiments from the experiments journey.
 * Filters for experiments that have been visited (visited = true).
 */
export function getVisitedExperiments(): [string, ExperimentAndVariation][] {
  try {
    const visitedExperiments: [string, ExperimentAndVariation][] =
      Object.entries(getExperimentsJourney())
        .filter(([, [, , visited]]) => visited)
        .map(([context, [experimentName, variationName]]) => [
          context,
          { experimentName, variationName },
        ]);

    return visitedExperiments;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error getting visited experiments:", error);
    captureException(error, "getVisitedExperiments");
    return [];
  }
}

export function getECTExperiments() {
  // Provide experiments as GET query parameters for experiment overlap testing
  const params = new URLSearchParams(window.location.search);
  const experiments = params.getAll("experiment").map((item) => {
    const [name, variation] = item.split(".");
    return { name, variation };
  });
  if (experiments != null && experiments.length > 0) {
    return experiments;
  }
  return [];
}

export const getMeristemExperimentsString = (): string => {
  const visitedExperiments = Object.values(getExperimentsJourney())
    .filter(([, , visited]) => visited)
    .map(
      ([experimentName, experimentVar]) => `${experimentName}--${experimentVar}`
    );

  const uniqueVisitedExperiments = [...new Set(visitedExperiments)];

  if (uniqueVisitedExperiments.length === 0) {
    return undefined;
  }
  return uniqueVisitedExperiments.join();
};
